export default __webpack_public_path__ + "static/media/bootstrap.rtl.css.006b3e80.map";